import * as angular from "angular";
import template from "./entity-businesses-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import {
	All,
	Pattern
} from "../../../../services/security/actionScopes";
import type {
	EntityModel,
	EntityOperation,
	EntityTypeConfig
} from "./entityModalTabTypes";

export interface EntityBusinessesTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
	put: EntityOperation;
	post: EntityOperation;
}

// eslint-disable-next-line no-redeclare
export class EntityBusinessesTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const canReadEntityBusiness = globs.entityTypes.byType(this.typeConfig.Code).business.byType("*").read;
		const canReadBusiness = globs.business.byType("*").read;
		const canViewBusiness = new All([
			new Pattern(canReadEntityBusiness),
			new Pattern(canReadBusiness)
		]);

		this.tab = {
			name: "Businesses",
			code: "BUSINESSES",
			isAvailable: this.securityService.isActionScopeAllowed(canViewBusiness)
				&& !!this.typeConfig.Businesses?.IsSupported
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-businesses-tab", [])
	.component("entityBusinessesTab", {
		controller: EntityBusinessesTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			put: "=",
			post: "="
		}
	})
	.name;
